import { fastagAccount, fuelCardAccount, getUserAccountList, handleKeyDown, uploadFiles } from "_services";
import {
  getFastagTxnList,
  getFuelCardAccountDropdownData,
  getFuelStationListData,
  getFuelTxnList,
} from "_services/accountsServices/fuelStationServices";
import { getFuelApi } from "_services/dropdownServices/dropdownService";
import {
  CommonCanvas,
  CommonDatePicker,
  CommonInput,
  CommonModal,
  CustomSelect,
  SkeletonInput,
} from "components";
import { UserContext } from "context";
import { addFuelTransaction, addTransationFreight } from "features";
import { errorSchema, utils } from "helper";
import AddEditFuelStation from "modals/AddEditFuelStation";
import AddTransctionsModal from "modals/AddTransctionsModal";
import moment from "moment";
import Loading from "pages/Loading";
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import toast from "react-hot-toast";
import { IoCloseCircle } from "react-icons/io5";
import { useDispatch } from "react-redux";
import { StorageServices } from "utils";
import StorageService from "utils/StorageServices/StorageServices";

const arryOptions = [
  { label: "Arjun", value: "01" },
  { label: "Anvit", value: "02" },
];

const AddFuelModal = (props) => {
  const { tripId, closeModal, callBackFreight, transactionList, isOpen, tripDetais } =
    props;

  const initiFrom = {
    category: "",
    sub_category: "",
    fuel_station_id: "",
    account_category: "",
    account_sub_category: "",
    account_id: "",
    fuel_ltr: "",
    fuel_rate: "",
    amount: "",
    date: new Date(),
    description: "",
    slip_no: "",
    transaction_no: "",
    fuelcard_account_id: "",
    fuelcard_master_id: "",
    vendor_type: "",
    vendor_id: "",
    vendor_bank_account: "",
    trip_id: "",
    branch_id: "",
    company_id: StorageService?.getCompanyId(),
    vehicle_id: "",
    file: [],
    is_approval: "",
  };

  const { masterData, globTripDetails } = useContext(UserContext);
  const dispatch = useDispatch();
  const [form, setForm] = useState(initiFrom);
  const [formError, setFormError] = useState("");
  const [isLoadding, setIsLoadding] = useState(false);
  const [fuelStationList, setFuelStationList] = useState([]);
  const [filter, setFilter] = useState({
    limit: 10,
    offset: 1,
    search: "",
    status: 1,
    associate_status: 0,
  });
  const debounceTimer = useRef(null);
  const [freightTypeList, setFreightTypeList] = useState([]);
  const [freigtAccount, setFreigtAccount] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isLoadingSave, setIsLoadingSave] = useState(false);
  const [accountList, setAccountList] = useState([]);
  const [accountLoading, setAccountLoading] = useState(false);
  const [showOffcanvasFuel, setShowOffcanvasFuel] = useState(false);
  const [showOffcanvasFasTag, setShowOffcanvasFasTag] = useState(false);
  const [fuelCardAccountList, setFuelCardAccountList] = useState([]);
  const [fuelTransactionList, setFuelTransactionList] = useState([]);
  const balance = props?.transactionList?.freight_summary?.balance;

  useEffect(() => {
    getMasterFreight();
  }, []);

  useEffect(() => {
    if (form?.sub_category == 1) {
      getDataFuelStationList();
    }
    if (form?.sub_category == 2) {
      getDataFuelStationList();
    }
    if (form?.sub_category == 3) {
      getAccountListHandler(3);
    }
  }, [form?.sub_category]);

  const getMasterFreight = async () => {
    const payload = {
      type: "add_freight",
    };

    try {
      const fuelType =
        isOpen?.type === "fuel_driver" ? "driver_fuels" : "supplier_fuels";
      const details = masterData?.[fuelType]?.sub_type?.map((item) => {
        return {
          label: item?.name,
          value: item?.id,
          id: item?._id,
          status: item?.status,
          category_id: masterData?.[fuelType]?.id,
          type: masterData?.[fuelType]?.type,
        };
      });

      if (details) {
        setForm({
          ...form,
          trip_id: props?.tripId,
          category: parseInt(details[0]?.category_id),
          sub_category: parseInt(details[0]?.value),
        });
        setFreightTypeList(details);
      }
      // }
    } catch { }
  };

 

  // Helper function to calculate fuel values
  const calculateFuelValues = (form, changedField) => {
    const { fuel_ltr, fuel_rate, amount } = form;

    if (changedField === "fuel_ltr" || changedField === "fuel_rate") {
      if (fuel_ltr && fuel_rate) {
        return { ...form, amount: (parseFloat(fuel_ltr) * parseFloat(fuel_rate)).toFixed(2) };
      } else {
        return { ...form, amount: "" };
      }
    } else if (changedField === "amount") {
      if (amount) {
        if (fuel_ltr) {
          return { ...form, fuel_rate: (parseFloat(amount) / parseFloat(fuel_ltr)).toFixed(2) };
        }
        else if (fuel_rate) {
          return { ...form, fuel_ltr: (parseFloat(amount) / parseFloat(fuel_rate)).toFixed(2) };
        }


      } else {
        return { ...form, fuel_ltr: "", fuel_rate: "" };
      }
    }
    return form;
  };

  const performValidation = async (updatedForm) => {
    if (formError) {
      const validationResult = await utils.checkFormError(
        {
          ...updatedForm,
          balance: balance,
          ownerShip: globTripDetails?.vehicle_ownership,
        },
        errorSchema.addFuelSchemaTrip
      );

      if (validationResult === true) {
        setFormError("");
      } else {
        setFormError(validationResult);
      }
    }
  };

  const handleOnChange = async (name, value) => {
    // Always update the form immediately for responsive UI
    setForm((prevForm) => ({
      ...prevForm,
      [name]: value,
    }));

    // Clear existing timer
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    // For amount field, debounce the calculation
    if (name === "amount") {
      debounceTimer.current = setTimeout(() => {
        setForm((prevForm) => {
          const updatedForm = calculateFuelValues(prevForm, name);
          performValidation(updatedForm);
          return updatedForm;
        });
      }, 500); // Wait 500ms after user stops typing
    } else {
      // For fuel_ltr and fuel_rate, calculate immediately
      setForm((prevForm) => {
        const updatedForm = calculateFuelValues(prevForm, name);
        performValidation(updatedForm);
        return updatedForm;
      });
    }
  };
  const onSubmitFuel = async (approve) => {
    const validationResult = await utils.checkFormError(
      {
        ...form,
        balance: balance,
        ownerShip: globTripDetails?.vehicle_ownership,
      },
      errorSchema.addFuelSchemaTrip
    );

    console.log("validationResult",validationResult)
    const payload = {
      type: form?.category,
      sub_type: parseInt(form?.sub_category),
      fuel_station_id: form?.fuel_station_id,
      account_category:
        globTripDetails?.vehicle_ownership == 2 ? null : form?.account_category,
      account_sub_category:
        globTripDetails?.vehicle_ownership == 2
          ? null
          : form?.account_sub_category,
      account_id:
        globTripDetails?.vehicle_ownership == 2 ? "" : form?.account_id,
      fuel_ltr: form?.fuel_ltr,
      fuel_rate: form?.fuel_rate,
      amount: form?.amount,
      date: utils.convertToISO(form?.date, true),
      description: form?.description,
      slip_no: parseInt(form?.sub_category) === 1 ? form?.slip_no : "",
      transaction_no:
        parseInt(form?.sub_category) === 2 ? form?.transaction_no : "",
      fuelcard_account_id: form?.fuelcard_account_id
        ? form?.fuelcard_account_id
        : "",
      fuelcard_master_id: form?.fuelcard_master_id
        ? form?.fuelcard_master_id
        : "",
      
      trip_id: tripId,
      branch_id: globTripDetails?.branch_id?._id,
      company_id: form?.company_id,
      vehicle_id: globTripDetails?.vehicle_id?._id,
      file: form?.file,
      is_approval: approve,
    };

    if (validationResult === true) {
      approve == 0 ? setIsLoadding(true) : setIsLoadingSave(true);
      try {
        const res = await dispatch(addFuelTransaction(payload));
        if (res?.payload?.responseCode === 200) {
          setIsLoadding(false);
          setIsLoadingSave(false);
          closeModal();
          callBackFreight();
        } else {
          setIsLoadding(false);
          setIsLoadingSave(false);
        }
      } catch {
        setIsLoadding(false);
        setIsLoadingSave(false);
      }
    } else {
      setIsLoadding(false);
      setIsLoadingSave(false);
      setFormError(validationResult);
    }
  };

  const getDataFuelStationList = async () => {
    try {
      setAccountLoading(true);
      let object = {
        ...filter,
        company_id: StorageService.getCompanyId(),
        firm_id: tripDetais?.interfirm == 1 ? tripDetais?.vehicle_firm?._id : tripDetais?.firm_id?._id

      };

      if (form?.sub_category == 1) {
        const res = await getFuelApi(object);
        if (res?.responseCode == 200) {
          setAccountLoading(false);
          const list = res?.data?.fuelstation_list?.map((item) => {
            return {
              ...item,
              label: item?.name,
              value: item?._id,
            };
          });
          setFuelStationList(list);
          setForm({
            ...form,
            fuel_station_id: list[0]?.value,
            account_id: "",
            account_category: null,
            account_sub_category: null,
            fuelcard_account_id: "",
            fuelcard_master_id: "",
          });
        } else {
          setAccountLoading(false);
        }

        //           handleOnChange("fuel_station_id", list[0]?.value);
        // handleOnChange("account_id", "");
        // handleOnChange("account_category", "");
        // handleOnChange("account_sub_category", "");
      } else if (form?.sub_category == 2) {
        const res = await getFuelCardAccountDropdownData({
          company_id: StorageService?.getCompanyId(),
          offset: 1,
          limit: 2000,
          search: "",
          firm_id: tripDetais?.interfirm == 1 ? tripDetais?.vehicle_firm?._id : tripDetais?.firm_id?._id

        });

        if (res?.responseCode == 200) {
          setAccountLoading(false);
          const list = res?.data?.fuelcard_list?.map((item) => {
            return {
              ...item,
              label: item?.account_number,
              value: item?._id,
            };
          });

          setFuelStationList(list);
          setForm({
            ...form,
            fuelcard_account_id: list[0]?.value,
            fuelcard_master_id: list[0]?.fuelcard_master_id,
            account_id: "",
            account_category: null,
            account_sub_category: null,
            fuel_station_id: "",
          });
        } else {
          setAccountLoading(false);
        }
      } else {
        setAccountLoading(false);
        setAccountList([]);
      }
    } catch (error) {
      setAccountLoading(false);
      setAccountList([]);
      // throw error;
    }
  };

  const getAccountListHandler = async (acc) => {
    setAccountLoading(true);
    try {
      const res = await getUserAccountList({
        company_id: StorageService?.getCompanyId(),
        category_id: 1,
        sub_category_id: acc == 2 ? 12 : 3,
        account_id: "",
        firm_id: tripDetais?.interfirm == 1 ? tripDetais?.vehicle_firm?._id : tripDetais?.firm_id?._id
      });

      if (res?.responseCode === 200) {
        setAccountLoading(false);
        const details = res?.data?.account_list?.map((item) => {
          return {
            ...item,
            label: item?.name,
            value: item?._id,
          };
        });
        setAccountList(details);
        // handleOnChange("account_id", details[0].value);
        // handleOnChange("fuel_station_id", "");
        setForm({
          ...form,
          account_id: details[0].value,
          fuel_station_id: "",
          account_category: 1,
          account_sub_category: acc == 2 ? 12 : 3,
          fuelcard_account_id: "",
          fuelcard_master_id: "",
        });

      } else {
        setAccountLoading(false);
        setForm({
          ...form,
          account_id: "",
          fuel_station_id: "",
          account_category: 1,
          account_sub_category: acc == 2 ? 12 : 3,
          fuelcard_account_id: "",
          fuelcard_master_id: "",
        });
      }
    } catch (error) {
      setFuelStationList([]);
    } finally {
      setAccountLoading(false); // Stop loading in all cases
    }
  };

  const modifyProps = {
    ...props,
    isLoadding: isLoadding,
    disabled: isLoadding,
    isLoadingSave: isLoadingSave,
    onSubmit: onSubmitFuel,
  };

  const handleFileChange = async (e) => {
    if (
      e?.target?.files[0]?.type === "image/gif" ||
      e?.target?.files[0]?.type === "image/jpeg" ||
      e?.target?.files[0]?.type === "image/png"
    ) {
      setLoading(true);
      try {
        const formData = new FormData();
        formData.append("file", e?.target?.files[0]);
        const res = await uploadFiles(formData);
        if (res?.responseCode === 200) {
          var fileArray = [];
          fileArray.push(...form?.file, {
            filename: res?.data?.filename,
            path: res?.data?.path,
          });
          handleOnChange("file", fileArray);
          // setFormValue((s) => ({ ...s, file: fileArray }));
          setLoading(false);
          toast.success("Document added ");
        }
      } catch (error) {
        setLoading(false);
      }
    } else {
      toast.error("Invalid file, choose jpeg/png images");
    }
  };

  const documentRemove = (index) => {
    const newFromIput = [...form?.file];

    newFromIput.splice(index, 1);

    setForm({ ...form, file: newFromIput });
  };

  const addNewItemHandler = () => {
    setShowOffcanvasFuel(true);
  };

  const addNewFastItemHandler = () => {
    setShowOffcanvasFasTag(true);
  };

  const callBackFuel = (data) => {
    setForm({ ...form, fuel_station_id: data?._id });
    getDataFuelStationList();
  };

  const getApiCallFunction = () => {

    getfuelCardAccount();
    getFuelTxn()
  }

  const callBackDataFromFastag = (data) => {

    setForm({ ...form, fuelcard_account_id: data?._id });
    getDataFuelStationList();
  }

  const getFuelTxn = async () => {
    try {
      const res = await getFuelTxnList({ company_id: StorageServices?.getCompanyId() })

      if (res?.responseCode == 200) {
        setFuelTransactionList(res?.data?.transactions)
      } else {
        toast.error(res?.responseMessage)
      }
    } catch (error) {

    }
  }

  const getfuelCardAccount = async () => {
    try {
      const res = await fuelCardAccount({
        company_id: StorageServices.getCompanyId(),
      });

      if (res?.responseCode === 200) {
        // setFuelCardAccountList(
        //   res?.data?.fuelcard.flatMap((master) =>
        //     master.fuelcard_accounts.map((account) => ({
        //       ...account,
        //       master_name: master.master_name,
        //     }))
        //   )
        // );
        const transformDataToAccounts = (data) => {
          return data.map((master) => ({
            ...master,
            master_name: master?.fuelcard_company_id?.name || "",
          }));
        };

        setFuelCardAccountList(transformDataToAccounts(res?.data?.fuelcard));

      }
    } catch (error) { }
  };


  let AddTransactionAccountModal = {
    isOpen: showOffcanvasFasTag,
    closeModal: (e) => setShowOffcanvasFasTag(false),
    modalMainClass: "_dashCommon_Modal _mdModal",
    modalTitle: "Add Fuel Card ",
    footerPart: true,
    submitTitle: "Add Fuel Card",
    onlyFuelCardShow: true,
    callListApis: () => getApiCallFunction(),
    callBackDataFromFastag: callBackDataFromFastag,
    branchFirmId: tripDetais?.firm_id,
    hideAddNewOption: false
  }

  return (
    <div>
      <CommonCanvas {...modifyProps}>
        <div className="offcanvas-body">
          <div className="_lrCl_offCavBody __otr_expCanva">
            <div className="_othrExp_recBx">
              <div className="_clPay_flex">

                <div className="singleDiv">
                  <CommonDatePicker
                    name="date"
                    label=" Date"
                    startDate={form?.date}
                    setStartDate={(data) => {
                      handleOnChange("date", data);
                    }}
                    error={formError?.date}
                    focus={!!formError?.date}
                  />
                </div>
                {globTripDetails?.vehicle_ownership != 2 && (
                  <>
                    {freightTypeList.map((i) => {
                      return (
                        <div className="_dualCheckr_bx">
                          <input
                            className="form-check-input"
                            id={i?.value}
                            type="radio"
                            name="sub_category"
                            checked={i.value == form.sub_category}
                            value={i.value}
                            // disabled={i.value==2}
                            onChange={({ target: { name, value } }) =>
                              handleOnChange(name, parseInt(value))
                            }
                          />
                          <label for={i?.value} className="form-check-label">
                            {i?.label}
                          </label>
                        </div>
                      );
                    })}
                  </>
                )}

                <div className="singleDiv">
                  {form?.sub_category == 1 && (
                    <>
                      {!accountLoading ? (
                        <CustomSelect
                          label="Fuel Station"
                          // options={arryOptions}
                          options={
                            fuelStationList
                              ? fuelStationList
                              : { label: "", value: "" }
                          }
                          onSelect={(data) => {
                            handleOnChange("fuel_station_id", data.value);
                          }}
                          value={
                            form?.fuel_station_id
                              ? fuelStationList?.find(
                                (i) => i.value == form?.fuel_station_id
                              )
                              : { label: "", value: "" }
                          }
                          focus={!!formError?.fuel_station_id}
                          error={formError.fuel_station_id}
                          isAddButton={true}
                          addButtonAction={(e) => addNewItemHandler(e)}
                        />
                      ) : (
                        <SkeletonInput isLoading={accountLoading} />
                      )}
                    </>
                  )}

                  {form?.sub_category == 2 && (
                    <>
                      {!accountLoading ? (
                        <CustomSelect
                          label="Fuel Card"
                          // options={arryOptions}
                          options={
                            fuelStationList
                              ? fuelStationList
                              : { label: "", value: "" }
                          }
                          onSelect={(data) => {
                            handleOnChange("fuelcard_account_id", data.value);
                          }}
                          value={
                            form?.fuelcard_account_id
                              ? fuelStationList?.find(
                                (i) => i.value == form?.fuelcard_account_id
                              )
                              : { label: "", value: "" }
                          }
                          focus={!!formError?.fuelcard_account_id}
                          error={formError.fuelcard_account_id}
                          isAddButton={true}
                          addButtonAction={(e) => addNewFastItemHandler(e)}
                        />
                      ) : (
                        <SkeletonInput isLoading={accountLoading} />
                      )}
                    </>
                  )}

                  {form?.sub_category == 3 && (
                    <CustomSelect
                      label="Account"
                      // options={arryOptions}
                      options={
                        accountList ? accountList : { label: "", value: "" }
                      }
                      onSelect={(data) => {
                        handleOnChange("account_id", data.value);
                      }}
                      value={
                        form?.account_id
                          ? accountList?.find(
                            (i) => i.value == form?.account_id
                          )
                          : { label: "", value: "" }
                      }
                      focus={!!formError?.account_id}
                      error={formError.account_id}
                    />
                  )}
                </div>
                <div className="singleDiv">
                  <div className="flxInr">
                    <div className="halfDiv">
                      <CommonInput
                        type="text"
                        label="LTR"
                        placeholder="LTR"
                        name="fuel_ltr"
                        value={form?.fuel_ltr}
                        // onChange={({ target: { name, value } }) => {
                        //   const validValue = value.replace(/[^0-9.]/g, "");
                        //   const formattedValue = validValue.includes(".")
                        //     ? validValue.split(".")[0] +
                        //     "." +
                        //     validValue.split(".")[1].slice(0, 2)
                        //     : validValue;
                        //   if (value === "0") {
                        //     handleOnChange(name, formattedValue);
                        //     return;
                        //   }
                        //   handleOnChange(name, formattedValue);
                        // }}

                        onChange={({ target: { name, value } }) => {
                          // Remove non-numeric and non-decimal characters
                          let validValue = value.replace(/[^0-9.]/g, "");

                          // If starts with "0" and next character is not ".", remove leading 0
                          // Example: "05" -> "5", but "0.5" stays as "0.5"
                          if (validValue.startsWith("0") && validValue.length > 1 && validValue[1] !== ".") {
                            validValue = validValue.slice(1);
                          }

                          // Handle multiple decimals - keep only first one
                          const parts = validValue.split(".");
                          if (parts.length > 2) {
                            validValue = parts[0] + "." + parts.slice(1).join("");
                          }

                          // Limit to 2 decimal places
                          const formattedValue = validValue.includes(".")
                            ? validValue.split(".")[0] + "." + validValue.split(".").slice(1).join("").slice(0, 2)
                            : validValue;

                          handleOnChange(name, formattedValue);
                        }}

                        focus={!!formError?.fuel_ltr}
                        error={formError.fuel_ltr}
                        onKeyDown={handleKeyDown}
                        maxLength={10}
                      />
                    </div>

                    <div className="halfDiv">
                      <CommonInput
                        type="text"
                        label="Rate"
                        placeholder="Rate"
                        name="fuel_rate"
                        className="__rupeeSymbol"
                        rupeeSymbol={true}
                        value={form?.fuel_rate}
                        onChange={({ target: { name, value } }) => {
                          // Remove non-numeric and non-decimal characters
                          let validValue = value.replace(/[^0-9.]/g, "");

                          // If starts with "0" and next character is not ".", remove leading 0
                          // Example: "05" -> "5", but "0.5" stays as "0.5"
                          if (validValue.startsWith("0") && validValue.length > 1 && validValue[1] !== ".") {
                            validValue = validValue.slice(1);
                          }

                          // Handle multiple decimals - keep only first one
                          const parts = validValue.split(".");
                          if (parts.length > 2) {
                            validValue = parts[0] + "." + parts.slice(1).join("");
                          }

                          // Limit to 2 decimal places
                          const formattedValue = validValue.includes(".")
                            ? validValue.split(".")[0] + "." + validValue.split(".").slice(1).join("").slice(0, 2)
                            : validValue;

                          handleOnChange(name, formattedValue);
                        }}
                        focus={!!formError?.fuel_rate}
                        error={formError.fuel_rate}
                        onKeyDown={handleKeyDown}
                        maxLength={6}
                      />
                    </div>
                    <div className="singleDiv">
                      <CommonInput
                        type="text"
                        label="Amount"
                        placeholder="Amount "
                        name="amount"
                        className="__rupeeSymbol"
                        rupeeSymbol={true}
                        value={form.amount}
                        // onChange={({ target: { name, value } }) => {
                        //   const validValue = value.replace(/[^0-9.]/g, "");
                        //   const formattedValue = validValue.includes(".")
                        //     ? validValue.split(".")[0] +
                        //     "." +
                        //     validValue.split(".")[1].slice(0, 2)
                        //     : validValue;
                        //   handleOnChange(name, formattedValue);
                        // }}
                        onChange={({ target: { name, value } }) => {
                          // Remove non-numeric and non-decimal characters
                          let validValue = value.replace(/[^0-9.]/g, "");

                          // If starts with "0" and next character is not ".", remove leading 0
                          // Example: "05" -> "5", but "0.5" stays as "0.5"
                          if (validValue.startsWith("0") && validValue.length > 1 && validValue[1] !== ".") {
                            validValue = validValue.slice(1);
                          }

                          // Handle multiple decimals - keep only first one
                          const parts = validValue.split(".");
                          if (parts.length > 2) {
                            validValue = parts[0] + "." + parts.slice(1).join("");
                          }

                          // Limit to 2 decimal places
                          const formattedValue = validValue.includes(".")
                            ? validValue.split(".")[0] + "." + validValue.split(".").slice(1).join("").slice(0, 2)
                            : validValue;

                          handleOnChange(name, formattedValue);
                        }}
                        onKeyDown={handleKeyDown}
                        focus={!!formError?.amount}
                        error={formError.amount}
                        maxLength={10}
                      />
                      <p className="_bottomPLine">
                        This entry will be marked credit for Fuel Station
                      </p>
                    </div>
                    {parseInt(form?.sub_category) == 1 && (
                      <div className="singleDiv">
                        <CommonInput
                          type="text"
                          label="Slip Number"
                          placeholder="Slip Number"
                          name="slip_no"
                          value={form?.slip_no}
                          onChange={({ target: { name, value } }) => {
                            // Only allow letters and numbers (no special characters)
                            const cleanValue = value.replace(/[^a-zA-Z0-9]/g, '');
                            handleOnChange(name, cleanValue);
                          }}
                          focus={!!formError?.slip_no}
                          error={formError.slip_no}
                          maxLength={30}
                        />
                      </div>
                    )}

                    {parseInt(form?.sub_category) == 2 && (
                      <div className="singleDiv">
                        <CommonInput
                          type="text"
                          label="Transaction Number"
                          placeholder="Transaction Number"
                          name="transaction_no"
                          value={form?.transaction_no}
                          onChange={({ target: { name, value } }) => {
                            // Only allow letters and numbers (no special characters)
                            const cleanValue = value.replace(/[^a-zA-Z0-9]/g, '');
                            handleOnChange(name, cleanValue);
                          }}
                          focus={!!formError?.transaction_no}
                          error={formError.transaction_no}
                          maxLength={20}
                        />
                      </div>
                    )}
                    <div className="singleDiv">
                      <CommonInput
                        type="text"
                        label="Description"
                        placeholder="Description"
                        name="description"
                        value={form?.description}
                        onChange={({ target: { name, value } }) => {
                          handleOnChange(name, value);
                        }}
                        focus={!!formError?.description}
                        error={formError.description}
                      />
                    </div>
                  </div>
                </div>
              </div>

            </div>
            {/* <div className="checkBx_lv">

            </div> */}

            <div className="_othrExp_recBx">
              <div className="_clPay_flex">
                <div className="singleDiv">
                  <div className="_attatchmentBxs">
                    <div className="__addExp_fileBx">
                      <h4>Attachment</h4>
                      <input
                        type="file"
                        id="_fileUpload"
                        onClick={(e) => {
                          if (form?.file?.length >= 5) {
                            e.preventDefault(); // stop opening file dialog
                            toast.error("You can upload only 5 files");
                          }
                        }}
                        onChange={(e) => handleFileChange(e)}
                      />
                      <label htmlFor="_fileUpload" className="_uploadBtn">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="19"
                          viewBox="0 0 20 19"
                          fill="none"
                        >
                          <path
                            d="M5 0C6.28846 7.44425e-05 7.52716 0.497542 8.45778 1.38866C9.38839 2.27978 9.93908 3.49575 9.995 4.783L10 5V16C10.0008 16.7809 9.69698 17.5313 9.15323 18.0918C8.60948 18.6523 7.86861 18.9787 7.08804 19.0016C6.30747 19.0245 5.54873 18.7422 4.97303 18.2145C4.39733 17.6869 4.05006 16.9556 4.005 16.176L4 16V6C4.00028 5.74512 4.09788 5.49997 4.27285 5.31463C4.44782 5.1293 4.68695 5.01776 4.94139 5.00283C5.19584 4.98789 5.44638 5.07067 5.64183 5.23426C5.83729 5.39785 5.9629 5.6299 5.993 5.883L6 6V16C6.00028 16.2549 6.09788 16.5 6.27285 16.6854C6.44782 16.8707 6.68695 16.9822 6.94139 16.9972C7.19584 17.0121 7.44638 16.9293 7.64183 16.7657C7.83729 16.6021 7.9629 16.3701 7.993 16.117L8 16V5C8.00075 4.21909 7.69698 3.46867 7.15323 2.90818C6.60948 2.34769 5.86861 2.02132 5.08804 1.9984C4.30747 1.97548 3.54873 2.25784 2.97303 2.78546C2.39733 3.31309 2.05006 4.0444 2.005 4.824L2 5V14C1.99972 14.2549 1.90212 14.5 1.72715 14.6854C1.55218 14.8707 1.31305 14.9822 1.05861 14.9972C0.804163 15.0121 0.553621 14.9293 0.358167 14.7657C0.162714 14.6021 0.0371036 14.3701 0.00699997 14.117L0 14V5C0 3.67392 0.526784 2.40215 1.46447 1.46447C2.40215 0.526784 3.67392 0 5 0ZM13 14H15C15.2549 14.0003 15.5 14.0979 15.6854 14.2728C15.8707 14.4478 15.9822 14.687 15.9972 14.9414C16.0121 15.1958 15.9293 15.4464 15.7657 15.6418C15.6021 15.8373 15.3701 15.9629 15.117 15.993L15 16H13C12.7451 15.9997 12.5 15.9021 12.3146 15.7272C12.1293 15.5522 12.0178 15.313 12.0028 15.0586C11.9879 14.8042 12.0707 14.5536 12.2343 14.3582C12.3979 14.1627 12.6299 14.0371 12.883 14.007L13 14ZM13 10H18.5C18.7549 10.0003 19 10.0979 19.1854 10.2728C19.3707 10.4478 19.4822 10.687 19.4972 10.9414C19.5121 11.1958 19.4293 11.4464 19.2657 11.6418C19.1021 11.8373 18.8701 11.9629 18.617 11.993L18.5 12H13C12.7451 11.9997 12.5 11.9021 12.3146 11.7272C12.1293 11.5522 12.0178 11.313 12.0028 11.0586C11.9879 10.8042 12.0707 10.5536 12.2343 10.3582C12.3979 10.1627 12.6299 10.0371 12.883 10.007L13 10ZM13 6H18.5C18.7549 6.00028 19 6.09788 19.1854 6.27285C19.3707 6.44782 19.4822 6.68695 19.4972 6.94139C19.5121 7.19584 19.4293 7.44638 19.2657 7.64183C19.1021 7.83729 18.8701 7.9629 18.617 7.993L18.5 8H13C12.7451 7.99972 12.5 7.90212 12.3146 7.72715C12.1293 7.55218 12.0178 7.31305 12.0028 7.05861C11.9879 6.80416 12.0707 6.55362 12.2343 6.35817C12.3979 6.16271 12.6299 6.0371 12.883 6.007L13 6ZM13 2H18.5C18.7549 2.00028 19 2.09788 19.1854 2.27285C19.3707 2.44782 19.4822 2.68695 19.4972 2.94139C19.5121 3.19584 19.4293 3.44638 19.2657 3.64183C19.1021 3.83729 18.8701 3.9629 18.617 3.993L18.5 4H13C12.7451 3.99972 12.5 3.90212 12.3146 3.72715C12.1293 3.55218 12.0178 3.31305 12.0028 3.05861C11.9879 2.80416 12.0707 2.55362 12.2343 2.35817C12.3979 2.16271 12.6299 2.0371 12.883 2.007L13 2Z"
                            fill="#1956F6"
                          />
                        </svg>
                        <span>{loading ? "Uploadding" : "Add File"}</span>
                      </label>
                      {formError?.file && (
                        <span className="input_drop_error">
                          {formError?.file}
                        </span>
                      )}
                    </div>
                    <div className="img_fnex_src">
                      {form?.file?.length > 0 &&
                        form?.file?.map((el, index) => {
                          return (
                            <>
                              <div className="pos-relative">
                                <img
                                  className="_pdfIcon_sigxe"
                                  src={`${masterData?.s3_url}${el?.path}`}
                                  alt=""
                                />
                                <span className="_clDel_icon">
                                  <IoCloseCircle
                                    onClick={() => documentRemove(index)}
                                  />
                                </span>
                              </div>
                            </>
                          );
                        })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {globTripDetails?.vehicle_ownership == 2 && (
          <div className="_balSuccess">
            <p>Balance</p>

            <p>
              {(
                props?.transactionList?.freight_summary?.balance - form?.amount
              )?.toFixed(2)}
            </p>
          </div>
        )}
      </CommonCanvas>

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvasFuel ? "show" : ""
          }`}
        tabIndex={-1}
        style={{ visibility: showOffcanvasFuel ? "visible" : "hidden" }}
      >
        {showOffcanvasFuel && (
          <AddEditFuelStation
            isOpen={showOffcanvasFuel}
            onClose={(e) => setShowOffcanvasFuel(false)}
            callBackFuel={callBackFuel}
            hideAddNewOption={false}
            branchFirmId={tripDetais?.firm_id}

          />
        )}
      </div>
      <div className={showOffcanvasFuel ? "offBack_drop" : ""}></div>

      {/* <div
        className={`offcanvas offcanvas-end common_offCanvas ${
          showOffcanvasFasTag ? "show" : ""
        }`}
        tabIndex={-1}
        style={{ visibility: showOffcanvasFasTag ? "visible" : "hidden" }}
      > */}
      {showOffcanvasFasTag
        && (
          <AddTransctionsModal {...AddTransactionAccountModal} />

        )
      }
      {/* </div> */}
      <div className={showOffcanvasFasTag ? "offBack_drop" : ""}></div>
    </div>
  );
};

export default AddFuelModal;
